import { NodeSpec } from 'prosemirror-model';
import { liftListItem, sinkListItem } from 'prosemirror-schema-list';
import { Command } from 'prosemirror-state';
import { isInList } from '../queries/isInList';
import { CommandProps } from '../types';
import { BaseNode } from './base/BaseNode';

export class ListItem extends BaseNode {
  constructor() {
    super('list_item');
  }

  get schema(): NodeSpec {
    return {
      content: 'block+',
      defining: true,
      draggable: true,
      parseDOM: [{ tag: 'li' }],
      toDOM: () => ['li', 0],
    };
  }

  commands({ schema }: CommandProps): Record<string, Command> {
    return {
      // Enter: (state, dispatch) => {
      //   if (!isInList(state)) {
      //     return false;
      //   }
      //   if (state.selection.empty && state.selection.$anchor.parent.content.size === 0) {
      //     return liftListItem(schema.nodes.list_item)(state, dispatch);
      //   }
      //   return splitListItem(schema.nodes.list_item)(state, dispatch);
      // },
      Tab: sinkListItem(schema.nodes.list_item),
      'Shift-Tab': liftListItem(schema.nodes.list_item),
      'Mod-]': sinkListItem(schema.nodes.list_item),
      'Mod-[': liftListItem(schema.nodes.list_item),
      'Shift-Enter': (state, dispatch) => {
        if (!isInList(state)) {
          return false;
        }
        if (!state.selection.empty) {
          return false;
        }

        const { tr, selection } = state;
        dispatch?.(tr.split(selection.to));
        return true;
      },
    };
  }
}
